/**
 * API key data access (ADR-0016).
 *
 * Mirrors go-service/internal/api/api_keys.go: the keys this RMS issues so
 * intake can address it as a Backend. `key` comes back on the mint and
 * nowhere else — the server stores a SHA-256 digest, so there is no
 * endpoint that could return it a second time.
 */
import { apiFetch } from "../../../shared/api-client";
import { resource } from "./resource";

export interface ApiKey {
  id: string;
  name: string;
  /** First 8 characters of the issued key — never the secret. */
  prefix: string;
  created_at: string | null;
  created_by: string;
  last_used_at: string | null;
  revoked_at: string | null;
}

/** The mint response: the row, plus the one and only sight of the key. */
export interface MintedApiKey {
  api_key: ApiKey;
  key: string;
}

const keys = resource<ApiKey[]>("/api/admin/api-keys", "api_keys");

export const listApiKeys = (signal?: AbortSignal): Promise<ApiKey[]> =>
  keys.get(signal);

export const createApiKey = (name: string): Promise<MintedApiKey> =>
  apiFetch<MintedApiKey>("/api/admin/api-keys", {
    method: "POST",
    body: { name },
  });

export const revokeApiKey = async (id: string): Promise<void> => {
  await apiFetch<void>(`/api/admin/api-keys/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
};
